import React from 'react'
import { Box } from '@mui/material'
import { PlayGame } from '../components/PlayGame'

interface PlayGameWithoutIntroductionPageProps {
  className?: string
}

/**
 * PlayGameWithoutIntroductionPage - Play game directly without introduction
 * Users enter the team lobby directly
 * Includes permission checking for gamers before starting the game
 */
export const PlayGameWithoutIntroductionPage: React.FC<PlayGameWithoutIntroductionPageProps> = ({ className = '' }) => {
  // Permissions granted, show game
  return (
    <Box className={className}>
      <PlayGame />
    </Box>
  )
}
